import {
  CalendarDaysIcon,
  ChatBubbleLeftRightIcon,
  SparklesIcon,
  StarIcon,
  TruckIcon,
  UserCircleIcon,
  WalletIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import PillTabs, { PillTab } from "./PillTabs";
import { CogIcon } from "lucide-react";

interface TabProps {
  activeTab: number;
  onTabChange: (tabIndex: number) => void;
  userData: User;
}

const TABS: PillTab[] = [
  { key: 0, label: "Informations Générales", icon: UserCircleIcon },
  { key: 1, label: "Trajets", icon: TruckIcon },
  { key: 2, label: "Réservations", icon: CalendarDaysIcon },
  { key: 3, label: "Avis des Réservations", icon: StarIcon },
  { key: 4, label: "Avis des Trajet", icon: ChatBubbleLeftRightIcon },
  { key: 5, label: "Solde", icon: WalletIcon },
  { key: 6, label: "Historique des points", icon: SparklesIcon },
  { key: 7, label: "Configuration de l'app", icon: CogIcon },
];

const GUEST_TABS: PillTab[] = [
  { key: 0, label: "Informations Générales", icon: UserCircleIcon },
  { key: 2, label: "Réservations", icon: CalendarDaysIcon },
];

export const UserDetailTabs: React.FC<TabProps> = ({
  activeTab,
  onTabChange,
  userData,
}) => (
  <PillTabs
    tabs={userData?.email !== "guest-user@venez.ma" ? TABS : GUEST_TABS}
    activeTab={activeTab}
    onTabChange={onTabChange}
  />
);
